/* ========================================================================
   Umbraco Forms
 ========================================================================== */

(function () {
  'use strict';

  let loggedError = false;

  function init() {
    const forms = document.querySelectorAll('.umbraco-forms-form');

    forms.forEach((form) => {
      const submitButtons = form.querySelectorAll('button[type="submit"]');
      // const container = form.closest('[data-umbraco-form]');
      // const tagField = form.querySelector('.umbraco-forms-field.tags input');

      // if (tagField) {
      //   tagField.value = container.dataset.mailchimpTags;
      // }

      form.addEventListener('submit', (event) => {
        LoadingOverlayManager.showOnBody();
      });

      submitButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          if (loggedError) return;

          window.setTimeout(function () {
            const formErrors = form.querySelectorAll('.field-validation-error');

            if (formErrors.length > 0) {
              // DATALAYER
              app.dataLayer.pushEvent('formError', {
                pageUrl: window.location.pathname,
                errorMessage: formErrors[0].innerText,
              });

              loggedError = true;
            }
          }, 250);
        });
      });
    });

    const captchaErrors = document.querySelectorAll('.umbraco-forms-form .ucaptcha .field-validation-error');
    if (captchaErrors.length > 0) {
      // DATALAYER
      app.dataLayer.pushEvent('formError', {
        pageUrl: window.location.pathname,
        errorMessage: captchaErrors[0].innerText,
      });
    }
  }

  init();
})();
